import { ApiInstance } from '@src/services/api-instance';
import { BrainTasksService } from './tasks/api-tasks';
import { BrainResourcesService } from './resources/brain-resources';
import { BrainAuthService } from './auth/brain-auth';
import { BrainTeamMembersService } from './team-members/brain-team-members';
import { BrainRunsService } from './runs/brain-runs';

export class BrainV1Service {
  private readonly client: ApiInstance;

  public tasks: BrainTasksService;
  public resources: BrainResourcesService;
  public auth: BrainAuthService;
  public teamMembers: BrainTeamMembersService;
  public runs: BrainRunsService;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/v1`, client.getTimeout());

    this.tasks = new BrainTasksService(this.client);
    this.resources = new BrainResourcesService(this.client);
    this.auth = new BrainAuthService(this.client);
    this.teamMembers = new BrainTeamMembersService(this.client);
    this.runs = new BrainRunsService(this.client);
  }
}
